<template>
    <modal
        name="modal-confirmation"
        height="auto"
    >
        <div class="container">
            <div class="header-wrapper">
                <h3 class="header-title">{{title}}</h3>
            </div>
            <div class="body">
                {{message}}
            </div>
            <div class="buttons-wrapper">
                <button @click="accept" class="primary-button-xs">Aceptar</button>
                <button @click="close" class="secundary-button-xs">Cancelar</button>
            </div>
        </div>
    </modal>
</template>
<script>

export default {
    name:"ModalConfirmation",
    props: {
        title: String,
        message: String,
    },
    methods: {
        close() {
            this.$emit('close');
        },
        accept() { 
            this.$emit('accept')
        }
    }
}
</script>
<style lang="scss" scoped>

.container{
    background-color: #fff;
    border: 1px solid #e8e8e8;
    box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.14);
    width: 600px;
    height: auto;
}
.header-wrapper{
    border-bottom: 1px solid rgba(70,72,74,0.1);
    margin-bottom: 20px;
    padding: 0.7em 0.9em;
}
.header-title{
    color: #2a2a2e;
    font-family: 'miraimedium';
    font-size: 1.125em;
}
.body{
    padding: 0 30px;
    margin-bottom: 20px;
}
.comment-title{
    margin-bottom: 6px;
}

.buttons-wrapper{
    display: flex;
    justify-content: space-around;
    margin-bottom: 20px;
}

</style>